import { useEffect, useRef, useState } from "react";
import { formatNumber } from "../../utils";

interface AnimatedNumberProps {
  value: number;
  duration?: number;
  format?: (n: number) => string;
  className?: string;
}

const AnimatedNumber = ({
  value,
  duration = 800,
  format = formatNumber,
  className = "",
}: AnimatedNumberProps) => {
  const [display, setDisplay] = useState(0);
  const startedRef = useRef(false);
  const fromRef = useRef(0);

  useEffect(() => {
    const from = startedRef.current ? fromRef.current : 0;
    const to = value;
    startedRef.current = true;
    fromRef.current = to;

    const start = performance.now();
    let raf = 0;

    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const cur = Math.round(from + (to - from) * eased);
      setDisplay(cur);
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  return <span className={className}>{format(display)}</span>;
};

export default AnimatedNumber;
